export default __webpack_public_path__ + "static/media/rubinho.06c5a1b9.jpeg";